import EventBus from '../eventBus'

export default {
    methods: {
        generateUrlParameters(event, rangeSliderId = null, pageNumber = 1) {
            var _this = this;
            let urlParamaters = [];

            // Reset filter check
            this.showResetButton();

            if (event) {
                event.preventDefault();
            }

            // Update slider positions when submitting input
            if (rangeSliderId !== null) {

                let sliderInstance = document.getElementById('vue__range-slider-' + rangeSliderId);
                let updatedMin = parseInt(_this.settedFilters.ranges[rangeSliderId]['min_value'])
                let updatedMax = parseInt(_this.settedFilters.ranges[rangeSliderId]['max_value']);

                sliderInstance.noUiSlider.updateOptions({
                    start: [updatedMin, updatedMax]
                });
            }

            // Create and add taxonomy parameters
            if (this.postType == 'catalogus') {
                let productTextSearch = this.settedFilters.productTextSearch;
                if (productTextSearch.length > 0) {
                    let textParameter = this.createParameter(productTextSearch, 'taxonomy', 'custom_search=');
                    urlParamaters.push(textParameter);
                }

                let mainCatArray = this.settedFilters.checkedTaxonomies.website_main_category;
                if (mainCatArray[0].length > 0) {
                    let mainCatParameter = this.createParameter(mainCatArray, 'taxonomy', 'website_main_category=');
                    urlParamaters.push(mainCatParameter);
                }

                let productCatArray = this.settedFilters.checkedTaxonomies.product_category;
                if (productCatArray[0]) {
                    let productParameter = this.createParameter(productCatArray, 'taxonomy', 'product_category=');
                    urlParamaters.push(productParameter);
                }

                let themeValArray = this.settedFilters.checkedTaxonomies.thema_value;
                if (themeValArray[0]) {
                    let themaParameter = this.createParameter(themeValArray, 'taxonomy', 'thema_value=');
                    urlParamaters.push(themaParameter);
                }

                let playValValue = this.settedFilters.checkedTaxonomies.primary_play_value_id;
                if (playValValue > 0) {
                    let playParameter = this.createParameter(playValValue, 'taxonomy', 'primary_play_value_id=');
                    urlParamaters.push(playParameter);
                }

                let secPlayValArray = this.settedFilters.checkedTaxonomies.secondary_play_value_ids;
                if (secPlayValArray[0]) {
                    let secPlayParameter = this.createParameter(secPlayValArray, 'taxonomy', 'secondary_play_value_ids=');
                    urlParamaters.push(secPlayParameter);
                }
            }

            if (this.postType == 'projecten') {

                //
                //
                // Loopt through 'filters' prop to get all selectede values
                //
                //

                let projectFilters = this.filters.allExternalProjectFilters

                for (var key in projectFilters) {
                    let filterBlock = projectFilters[key];
                    let parameterBase = filterBlock.slug + '=';

                    //
                    // Create all text parameters
                    //
                    if (filterBlock.type == 'text' && filterBlock.value) {
                        if (filterBlock.value.length > 0) {
                            let textParameter = this.createParameter(filterBlock.value, 'taxonomy', parameterBase);
                            urlParamaters.push(textParameter);
                        }
                    }

                    //
                    // Create all checkbox parameters
                    //
                    if ((filterBlock.type == 'checkbox') && filterBlock.items.length > 0) {
                        let checkedItems = [];

                        // Loop through items and check if 'checked' == true, then add value to 'checkedItems' array
                        for (var itemKey in filterBlock.items) {
                            if (filterBlock.items[itemKey]['checked'] == true) {
                                checkedItems.push(filterBlock.items[itemKey]['value']);
                            }
                        }

                        if (checkedItems.length > 0) {
                            let checkedItemsParameter = this.createParameter(checkedItems, 'taxonomy', parameterBase);
                            urlParamaters.push(checkedItemsParameter);
                        }
                    }

                    //
                    // Create all radio parameters
                    //
                    if (filterBlock.type == 'radio' && filterBlock.checked) {
                        if (filterBlock.checked !== 'all') {
                            let radioParameter = this.createParameter(filterBlock.checked, 'taxonomy', parameterBase);
                            urlParamaters.push(radioParameter);
                        }
                    }

                    //
                    // Create all dropwdown parameters
                    //
                    if (filterBlock.type == 'dropdown' && filterBlock.selected) {
                        if (filterBlock.selected.length > 0 && filterBlock.selected !== "0") {
                            let dropdownParameter = this.createParameter(filterBlock.selected, 'taxonomy', parameterBase);
                            urlParamaters.push(dropdownParameter);
                        }
                    }
                }

            }

            // Create and add range paramters
            let settedRanges = this.settedFilters.ranges

            for (i = 0; i < settedRanges.length; i++) {

                const newI = i
                // this.settedFilters.ranges.forEach(function (rangeItem){
                let values = settedRanges[newI].min_value + ',' + settedRanges[newI].max_value;
                let parameterBase = settedRanges[newI].name + '=';
                let rangeParameter = _this.createParameter(values, 'range', parameterBase);
                urlParamaters.push(rangeParameter);
            }

            // 'Catalog' specific parameters
            if (this.postType == 'catalogus') {
                if (this.blogId == 3) {
                    urlParamaters.push('orderby=list_price');
                    urlParamaters.push('order=asc');
                    urlParamaters.push('lang=de');
                } else {
                    urlParamaters.push('orderby=list_price');
                    urlParamaters.push('order=asc');
                    urlParamaters.push('on_website_lappset=1');
                    urlParamaters.push('lang=nl');
                }
            }

            if (this.postType == 'projecten') {
                urlParamaters.push('language=' + this.language);
            }

            // Default paramaters

            // Add per_page parameter
            if (this.postType == 'catalogus') {
                urlParamaters.push('per_page=30');
            }

            if (this.postType == 'projecten') {
                urlParamaters.push('per_page=30');
            }

            // Add pagination parameter
            urlParamaters.push('page=' + pageNumber);

            // Build REST API URL and address bar URL
            let restUrl = window.location.origin + '/wp-json/wp/v2/' + this.postType + '?';

            if (this.postType == 'projecten') {
                restUrl = 'https://api.yalpinteractive.com/website/projects?';
            }

            let addressBarParameters = '';
            let i;
            for (i = 0; i < urlParamaters.length; i++) {

                // If is not last item then add ampersand
                let cur = i + 1
                if (cur != urlParamaters.length) {
                    restUrl += urlParamaters[i];
                    restUrl += '&';

                    addressBarParameters += urlParamaters[i];
                    addressBarParameters += '&';
                } else {
                    restUrl += urlParamaters[i];

                    addressBarParameters += urlParamaters[i];
                }
            }

            // Set parameters in address bar
            window.location.hash = '#!/' + addressBarParameters;

            EventBus.$emit('UPDATE_CATALOG', {restUrl: restUrl, pageNumber: pageNumber});
        },
        createParameter(value, type, base) {
            // console.log(value);
            if (type == 'taxonomy') {
                let parameterBase = base;

                if (typeof value == 'object') {
                    let i;
                    for (i = 0; i < value.length; i++) {
                        // If is not last item then add comma
                        let item = value[i];

                        // Adjust string to by compatible in url
                        if (typeof item == 'string') {
                            item = encodeURIComponent(item);
                        }

                        let cur = i + 1;
                        if (cur != value.length) {
                            parameterBase += item;
                            parameterBase += ',';
                        } else {
                            parameterBase += item;
                        }
                    }
                    if (value.length == 0) {
                        parameterBase = '';
                    }
                } else if (typeof value == 'number' || typeof value == 'string') {
                    // Adjust string to be compatible in url
                    if (typeof value == 'string') {
                        value = encodeURIComponent(value);
                    }
                    parameterBase += value;
                }
                let parameter = parameterBase;
                return parameter;

            } else if (type == 'range') {
                // console.log('createParameter', 'range');
                let parameter = base + value;
                return parameter;
            }
        },
    }
}
